import { render, staticRenderFns } from "./modelDrag.vue?vue&type=template&id=0e6ec3c4&scoped=true&"
import script from "./modelDrag.vue?vue&type=script&lang=js&"
export * from "./modelDrag.vue?vue&type=script&lang=js&"
import style0 from "./modelDrag.vue?vue&type=style&index=0&id=0e6ec3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6ec3c4",
  null
  
)

export default component.exports